function toCardinal(num) {
    if (!num)
        return '';
    try {
        const lastDigit = num % 10;
        const secondLastDigit = Math.floor((num % 100) / 10);
        if (lastDigit === 1 && secondLastDigit !== 1) {
            return `${num}st`;
        }
        else if (lastDigit === 2 && secondLastDigit !== 1) {
            return `${num}nd`;
        }
        else if (lastDigit === 3 && secondLastDigit !== 1) {
            return `${num}rd`;
        }
        else {
            return `${num}th`;
        }
    }
    catch (error) {
        return `${num}`;
    }
}
function fromCardinal(cardinal) {
    try {
        const num = parseInt(cardinal);
        if (!isNaN(num)) {
            const suffix = cardinal.slice(-2);
            if (suffix === 'st' || suffix === 'nd' || suffix === 'rd' || suffix === 'th') {
                return num;
            }
        }
        return null;
    }
    catch (error) {
        return null;
    }
}
function mapToCardinal(numbers) {
    if (numbers)
        return numbers.map(toCardinal);
    return [];
}
function mapFromCardinal(letters) {
    if (letters)
        return letters.map(fromCardinal);
    return [];
}
export { toCardinal, fromCardinal, mapToCardinal, mapFromCardinal };
